// 可以复用函数


// 价钱格式化
function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
        cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
        return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultTo(precision, 2);
        thousands = defaultTo(thousands, ",");
        decimal = defaultTo(decimal, ".");
        if (isNaN(number) || number == null) {
            return 0;
        }
        number = (number / 100).toFixed(precision);
        let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
        return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
        case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
        case "amount_with_space_separator":
            value = formatWithDelimiters(cents, 2, " ", ".");
            break;
        case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
        case "amount_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 2, "'", ".");
            break;
        case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
        case "amount_no_decimals_with_space_separator":
            value = formatWithDelimiters(cents, 0, " ");
            break;
        case "amount_no_decimals_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 0, "'");
            break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
        return formatString.replace(placeholderRegex, value);
    } else {
        return formatString.replace(placeholderRegex, value);
    }
}
// 获取产品信息
async function getProduct(handle){
    return new Promise(async (resolve, reject) => {
        fetch('/products/' + handle + '.js').then(response => {
            return response.json();
        }).then(data => {
            resolve(data);
        }).catch(error => {
            reject(error);
        });
    })
}
// 获取多个产品的数据
async function getAllProducts(products){
    return await Promise.all(products.map(product => getProduct(product.handle)));
}
// 去到结账页面
function goToCheckout(){
    window.location.href = '/checkout'
}
// 打开迷你弹窗购物车
function openMiniCart(res){
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: false,
        detail: {
            cart: res,
            openMiniCart: true
        }
    }));
}
// 获取购物车数据
async function getCart(){
    return new Promise(async (resolve, reject) => {
        fetch('/cart.js').then(response => {
            resolve(response.json());
        }).catch(error => {
            reject(error);
        });
    })
}
// 产品加入购物车  
async function addToCart(products){
    return new Promise(async (resolve, reject) => {
            fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                items: products
            })
        }).then((response) => {
            resolve(response.json());
        }).catch(error => {
            reject(error);
        });
    })
}
// 清空购物车
async function clearCart(){
    return new Promise(async (resolve, reject) => {
        fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then((response) => {
            resolve(response.json());
        }).catch(error => {
            reject(error);
        });
    })
}



// 可复用组件

// 可以共用继承的弹窗组件 淡入淡出效果
class OpenElement extends HTMLElement {
    constructor() {
        super();
        // 修改弹窗背景色
        this.show_background_color = 'rgba(0, 0, 0, 0.3)';
        this.timer = null;
    }
    connectedCallback() {
        this.onclick = () => this.hide();

        const box = this.querySelector('.popup--box');
        if (box) box.onclick = e => e.stopPropagation();

        const close = this.querySelector('.popup-close');
        if (close) close.onclick = () => this.hide();

        this.onmousemove = e => e.stopPropagation();
        this.ontouchmove = e => e.stopPropagation();
        this.onwheel = e => e.stopPropagation();
    }
    get open(){
        return this.hasAttribute('open')
    }
    set open(value){
        if(value){
            this.setAttribute('open', '')
        }else{
            this.removeAttribute('open')
        }
    }
    show() {
            console.log('show called', this);
        clearTimeout(this.timer);
        this.style.display = 'block';
        this.animate(
            {
                backgroundColor: this.show_background_color
            },
            {
                duration: 450,
                easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
                fill: 'forwards'
            }
        )
        this.timer = setTimeout(() => {
            this.open = true;
        }, 0)
    }
    hide() {
        clearTimeout(this.timer);
        this.open = false;
        this.animate(
            {
                backgroundColor: "rgba(0, 0, 0, 0)"
            },
            {
                duration: 450,
                easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
                fill: 'forwards'
            }
        )
        this.timer = setTimeout(() => {
            this.style.display = "none"
        }, 500)
    }
}


// 产品变体选择
var VariantSelect = class extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback(){
        this.init();
    }
    async init(){
        this.section_id = this.getAttribute('section-id');
        this.block_id = this.getAttribute('block-id');
        let handle = this.getAttribute('product-handle');
        if(!handle){
            return
        }
        this.product =await getProduct(handle)
        this.select = this.querySelector('select');
        if(!this.select){
          return
        }
        // 产品所有变体都不可用
        if(!this.product.available){
            // 变体选择为第一个
            this.select.selectedIndex = 0
        }
        // 默认为第一个变体
        this.variant = this.product.variants.find((variant) => variant.id == this.select.options[this.select.selectedIndex].value);
        // 如果限制了显示某一个变体
        if(this.hasAttribute('variant_id')){
            this.product.variants.forEach((variant,index) => {
                if(variant.id == this.getAttribute('variant_id')){
                    this.variant = variant;
                    this.select.selectedIndex = index;
                    this.eventVariantChange();
                }
            });
        }
        // 变体选择改变
        this.select.addEventListener('change', (event)=>{
            this.variant = this.product.variants.find((variant) => variant.id == event.target.value);
            this.eventVariantChange();
        });
        document.addEventListener(`${this.section_id}:section:loading`, (event) => {
            this.eventVariantChange();
        })
    }
    eventVariantChange(){
        document.documentElement.dispatchEvent(new CustomEvent(`${this.section_id}:variant:updated`, {
            bubbles: true,
            detail: {
                product: this.product,
                variant: this.variant,
                section_id: this.section_id,
                block_id:this.block_id
            }
        }));
    }
}
window.customElements.define('variant-select', VariantSelect);
 

// 
class GiraffeToolsCarePopup extends OpenElement {
    constructor() {
        super();
        // this.querySelector('.button-levels-1.product-item__cta').onclick = () => {
        //     this.hide();
        // };

    }
}
window.customElements.define('giraffe-tools-care-popup', GiraffeToolsCarePopup);

class customProductShowMore extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
    if (this._inited) return
    this._inited = true
        
    this.addEventListener("click", e => {
      const btn = e.target.closest(".open_popup")
      if (!btn) return

      this.querySelector("giraffe-tools-care-popup")?.show()
    })
  }
}
window.customElements.define('custom-product-show-more', customProductShowMore);

class customPopTarget extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
    if (this._inited) return
    this._inited = true
    this.addEventListener("click", e => {
      const btn = e.target.closest(".open_popup")
      if (!btn) return

      this.querySelector("custom-pop-content")?.show()
    })
  }
}
window.customElements.define('custom-pop-target', customPopTarget);

class customPopContent extends OpenElement {
    constructor() {
        super();
    }
}
window.customElements.define('custom-pop-content', customPopContent);

class customRcommendationsSwiper extends HTMLElement {
    constructor() {
        super()
        
    }
    connectedCallback() {
        setTimeout( () => this.initSwiper(), 0)
    }
    initSwiper() {
        const nextEl = this.querySelector(".swiper-button-next")
          , prevEl = this.querySelector(".swiper-button-prev")
          , swiperContainer = this.querySelector(".custom-swiper-container") || this
          , config = {
                slidesPerView: 2,
                slidesPerGroup: 1,
                spaceBetween: 10,
                slideToClickedSlide: false,
                breakpoints: {
                320: {
                slidesPerView: 2.1
                },
                768: {
                slidesPerView: 2.2
                }
            },
            };
        config.navigation = {
            nextEl,
            prevEl
        },
        new Swiper(swiperContainer,config)
    }
}
customElements.define("custom-recommendations-swiper", customRcommendationsSwiper);